module.exports = __webpack_public_path__ + "img/plus.c098f7ff.svg";